/** 租户侧账单统计 /metering/bill/floating-price-tenant（floatingPrice.vue） */
export default {
  floatingPriceTenantPage: {
    phDateStart: '开始日期',
    phDateEnd: '结束日期',
    phTenant: '租户名称/编号',
    phTenantType: '租户类型',
    phPayType: '付费模式',
    phArrearsType: '欠费类型',
    tenantType0: '租户',
    tenantType1: '公区',
    tenantType2: '其他',
    tenantType3: '光伏',
    optPayPrepaid: '预付费',
    optPayPostpaid: '后付费',
    arrearsType1: '电费欠费',
    arrearsType2: '水费欠费',
    arrearsType3: '服务费欠费',
    arrearsType4: '存在欠费',
    arrearsType5: '全部已缴清',
    btnSearch: '查询',
    btnReset: '重置',
    btnExport: '导出',
    exportCurrentPage: '导出当前页',
    exportSelected: '导出选中',
    exportAll: '导出全部',
    btnExpand: '展开',
    btnCollapse: '收起',
    kpiBillTotal: '应收租户费用(元)',
    kpiPayTotal: '实收租户费用(元)',
    kpiPrepaidRate: '预付费收缴率',
    sectionTitle: '账单统计',
    sortDefault: '默认排序',
    selectedLine: '已选择 <span class="count">{count}</span> 条数据',
    colTenantId: '租户ID',
    colResourceList: '资源列表',
    colTenantName: '租户名',
    colPayType: '付费模式',
    colElecAmt: '电费账单',
    colElecPayAmt: '电费账单(已缴费)',
    colElecNoPayAmt: '电费账单(未缴费)',
    colWaterAmt: '水费账单',
    colWaterPayAmt: '水费账单(已缴费)',
    colWaterNoPayAmt: '水费账单(未缴费)',
    colServiceAmt: '服务费账单',
    colServicePayAmt: '服务费账单(已缴费)',
    colServiceNoPayAmt: '服务费账单(未缴费)',
    msgTenantListFail: '获取租户列表失败',
    msgFetchFail: '获取数据失败',
    msgFetchStatFail: '获取账单统计数据失败',
    msgNoDataExport: '暂无数据可导出',
    msgExportOk: '导出成功！',
    msgExportOkSelected: '成功导出{count}条选中数据！',
    warnNoSelectedExport: '请先勾选要导出的数据',
    successExported: '成功导出 {count} 条数据',
    successExportedLimit: '共 {total} 条，已导出前 {count} 条',
    exporting: '正在导出...',
    msgExportFail: '导出失败，请重试',
    exportSheetName: '租户账单统计',
    filePrefix: '租户账单统计',
    resourceMore: '{name} 等{count}个资源'
  }
}
